import { useEffect as c } from "react";
const i = _ref => {
  let {
    wrapperRef: t,
    inputRef: r,
    setShowItems: e,
    searchTerm: n
  } = _ref;
  c(() => {
    const s = o => {
      const {
        current: u
      } = t;
      if (o.target === r.current && n) {
        e(!0);
        return;
      }
      u && !u.contains(o.target) && e(!1);
    };
    return window.addEventListener("mousedown", s), () => {
      window.removeEventListener("mousedown", s);
    };
  }, [r, n, e, t]);
};
export { i as useClickOutside };